/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./axios');

window.Vue = require('vue');

import Vuex from 'vuex'
window.Vue.use(Vuex);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('gift-list-component', require('./components/GiftListComponent.vue').default);
Vue.component('gift-detail-component', require('./components/GiftDetailComponent.vue').default);
Vue.component('lunar-new-year-2021-component', require('./components/events/LunarNewYear2021Component.vue').default);

// Sentry
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

window.Sentry = Sentry;

Sentry.init({
    dsn: 'https://aba4452b29d647b48aef1c30ca7d3811@o232714.ingest.sentry.io/5557567',
    // integrations: [
    //     new Integrations.BrowserTracing(),
    // ],

    tracesSampleRate: 1.0,
});

// Moment.js
window.moment = require('moment');

// bootstrap-input-spinner
require('bootstrap-input-spinner');

// Vee-validate
import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full';
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Recaptcha v3
import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, {
    siteKey: process.env.MIX_RECAPTCHA_SITE_KEY,
    loaderOptions: {
        useRecaptchaNet: true,
        autoHideBadge: true
    }
})

// Sweetalert2
window.Swal = require('sweetalert2')

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
